import React from 'react';
import { FaInfoCircle } from 'react-icons/fa';
import './hint-icon.css';

const HintIcon = ({ hint }) => {
  return (
    <div className="hint-icon-container">
      <FaInfoCircle className="hint-icon" />
      <span className="hint-text">{hint}</span>
    </div>
  );
};

export default HintIcon;
